import React from "react";

import ScrollView from "sub_components/Common/BloxScrollViewNew";
import SmallCard from "./SmallShareCard";

function renderShares(onClickFunc, shares = [1, 1, 1, 1, 1]) {
  return shares.map((share, index) => (
    <SmallCard
      key={`share-card-${share.storage_id}`}
      id={`share-card-${index}`}
      index={index + 1}
      share={share}
      onClick={() => onClickFunc(share.storage_id)}
      cypressId={`small-card-${index}`}
      type="share"
    />
  ));
}

const FrontSide = ({ shares, onFlip, onScroll, scrollTop, loading }) => {
  return (
    <>
      {shares && (
        <>
          <ScrollView scrollTop={scrollTop} onScrollStop={onScroll}>
            <div className="share-card-wrapper">
              <div className="shares-section">
                {renderShares(onFlip, shares)}
              </div>
            </div>
          </ScrollView>
          {shares.length > 4 && <div className="lower-filter"></div>}
        </>
      )}
      {!shares && loading && (
        <div className="shares-details loading header50">
          Loading shares data...
        </div>
      )}
      {!shares && !loading && (
        <div className="shares-details loading header50">
          There currently aren't any shares configured for this account. Please
          go to Share Detail to configure storage.
        </div>
      )}
    </>
  );
};

export default FrontSide;
